import * as Actions from 'reducks/stock/actions'
import { initialState } from 'reducks/reduxStore/initialState'

export const StockReducer = (state = initialState.stock, action: any) => {
  switch (action.type) {
    case Actions.FETCH_STOCKS:
      return {
        ...state,
        stocks: [...action.payload],
      }
    case Actions.INIT_STOCKS:
      return {
        is_set_unsubscribe: false,
        stocks: [],
        unsubscribe: () => null,
      }
    case Actions.INIT_STOCK_UNSUBSCRIBE:
      return {
        ...state,
        is_set_unsubscribe: false,
        unsubscribe: () => null,
      }
    case Actions.SET_STOCK_UNSUBSCRIBE:
      return {
        ...state,
        is_set_unsubscribe: true,
        unsubscribe: action.payload,
      }
    default:
      return state
  }
}
